export const fullStoryContentCatalog = [
  {
    id: "princeza-na-zrnu-graska",
    title: "Принцеза на зрну грашка",
    author: "Ханс Кристијан Андерсен",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9F%D1%80%D0%B8%D0%BD%D1%86%D0%B5%D0%B7%D0%B0_%D0%BD%D0%B0_%D0%B7%D1%80%D0%BD%D1%83_%D0%B3%D1%80%D0%B0%D1%88%D0%BA%D0%B0",
    audioAvailable: true
  },
  {
    id: "ruzno-pace",
    title: "Ружно паче",
    author: "Ханс Кристијан Андерсен",
    sourceUrl: "https://sr.wikisource.org/wiki/Ru%C5%BEno_pa%C4%8De",
    audioAvailable: true
  },
  {
    id: "devojcica-sa-sibicama",
    title: "Девојчица са шибицама",
    author: "Ханс Кристијан Андерсен",
    sourceUrl: "https://sr.wikisource.org/wiki/Djevojcica_sa_sibicama",
    audioAvailable: true
  },
  {
    id: "carevo-novo-odelo",
    title: "Царево ново одело",
    author: "Ханс Кристијан Андерсен",
    sourceUrl: "https://sr.wikisource.org/wiki/Carevo_novo_odelo",
    audioAvailable: true
  },
  {
    id: "pepeljuga",
    title: "Пепељуга",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9F%D0%B5%D0%BF%D0%B5%D1%99%D1%83%D0%B3%D0%B0",
    audioAvailable: true
  },
  {
    id: "medjedovic",
    title: "Међедовић",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9C%D0%B5%D1%92%D0%B5%D0%B4%D0%BE%D0%B2%D0%B8%D1%9B",
    audioAvailable: true
  },
  {
    id: "cardak-ni-na-nebu-ni-na-zemlji",
    title: "Чардак ни на небу ни на земљи",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A7%D0%B0%D1%80%D0%B4%D0%B0%D0%BA_%D0%BD%D0%B8_%D0%BD%D0%B0_%D0%BD%D0%B5%D0%B1%D1%83_%D0%BD%D0%B8_%D0%BD%D0%B0_%D0%B7%D0%B5%D0%BC%D1%99%D0%B8",
    audioAvailable: true
  },
  {
    id: "nemusti-jezik",
    title: "Немушти језик",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9D%D0%B5%D0%BC%D1%83%D1%88%D1%82%D0%B8_%D1%98%D0%B5%D0%B7%D0%B8%D0%BA",
    audioAvailable: true
  },
  {
    id: "zlatna-jabuka-i-devet-paunica",
    title: "Златна јабука и девет пауница",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%97%D0%BB%D0%B0%D1%82%D0%BD%D0%B0_%D1%98%D0%B0%D0%B1%D1%83%D0%BA%D0%B0_%D0%B8_%D0%B4%D0%B5%D0%B2%D0%B5%D1%82_%D0%BF%D0%B0%D1%83%D0%BD%D0%B8%D1%86%D0%B0",
    audioAvailable: true
  },
  {
    id: "stojsa-i-mladen",
    title: "Стојша и Младен",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A1%D1%82%D0%BE%D1%98%D1%88%D0%B0_%D0%B8_%D0%9C%D0%BB%D0%B0%D0%B4%D0%B5%D0%BD",
    audioAvailable: true
  },
  {
    id: "djavo-i-njegov-segrt",
    title: "Ђаво и његов шегрт",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%82%D0%B0%D0%B2%D0%BE_%D0%B8_%D1%9A%D0%B5%D0%B3%D0%BE%D0%B2_%D1%88%D0%B5%D0%B3%D1%80%D1%82",
    audioAvailable: true
  },
  {
    id: "prava-se-muka-ne-da-sakriti",
    title: "Права се мука не да сакрити",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9F%D1%80%D0%B0%D0%B2%D0%B0_%D1%81%D0%B5_%D0%BC%D1%83%D0%BA%D0%B0_%D0%BD%D0%B5_%D0%B4%D0%B0_%D1%81%D0%B0%D0%BA%D1%80%D0%B8%D1%82%D0%B8",
    audioAvailable: true
  },
  {
    id: "azdaja-i-carev-sin",
    title: "Аждаја и царев син",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%90%D0%B6%D0%B4%D0%B0%D1%98%D0%B0_%D0%B8_%D1%86%D0%B0%D1%80%D0%B5%D0%B2_%D1%81%D0%B8%D0%BD",
    audioAvailable: true
  },
  {
    id: "zmija-mladozenja",
    title: "Змија младожења",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%97%D0%BC%D0%B8%D1%98%D0%B0_%D0%BC%D0%BB%D0%B0%D0%B4%D0%BE%D0%B6%D0%B5%D1%9A%D0%B0",
    audioAvailable: true
  },
  {
    id: "djevojka-brza-od-konja",
    title: "Дјевојка бржа од коња",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%94%D1%98%D0%B5%D0%B2%D0%BE%D1%98%D0%BA%D0%B0_%D0%B1%D1%80%D0%B6%D0%B0_%D0%BE%D0%B4_%D0%BA%D0%BE%D1%9A%D0%B0",
    audioAvailable: true
  },
  {
    id: "djevojka-cara-nadmudrila",
    title: "Дјевојка цара надмудрила",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%94%D1%98%D0%B5%D0%B2%D0%BE%D1%98%D0%BA%D0%B0_%D1%86%D0%B0%D1%80%D0%B0_%D0%BD%D0%B0%D0%B4%D0%BC%D1%83%D0%B4%D1%80%D0%B8%D0%BB%D0%B0",
    audioAvailable: true
  },
  {
    id: "zlatoruni-ovan",
    title: "Златоруни ован",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%97%D0%BB%D0%B0%D1%82%D0%BE%D1%80%D1%83%D0%BD%D0%B8_%D0%BE%D0%B2%D0%B0%D0%BD",
    audioAvailable: true
  },
  {
    id: "ko-manje-iste-vise-mu-se-daje",
    title: "Ко мање иште, више му се даје",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9A%D0%BE_%D0%BC%D0%B0%D1%9A%D0%B5_%D0%B8%D1%88%D1%82%D0%B5%2C_%D0%B2%D0%B8%D1%88%D0%B5_%D0%BC%D1%83_%D1%81%D0%B5_%D0%B4%D0%B0%D1%98%D0%B5",
    audioAvailable: true
  },
  {
    id: "kome-bog-pomaze-niko-mu-nauditi-ne-moze",
    title: "Коме Бог помаже, нико му наудити не може",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9A%D0%BE%D0%BC%D0%B5_%D0%91%D0%BE%D0%B3_%D0%BF%D0%BE%D0%BC%D0%B0%D0%B6%D0%B5%2C_%D0%BD%D0%B8%D0%BA%D0%BE_%D0%BC%D1%83_%D0%BD%D0%B0%D1%83%D0%B4%D0%B8%D1%82%D0%B8_%D0%BD%D0%B5_%D0%BC%D0%BE%D0%B6%D0%B5",
    audioAvailable: true
  },
  {
    id: "kopanje-blaga",
    title: "Копање блага",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9A%D0%BE%D0%BF%D0%B0%D1%9A%D0%B5_%D0%B1%D0%BB%D0%B0%D0%B3%D0%B0",
    audioAvailable: true
  },
  {
    id: "kralj-i-cobanin",
    title: "Краљ и чобанин",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9A%D1%80%D0%B0%D1%99_%D0%B8_%D1%87%D0%BE%D0%B1%D0%B0%D0%BD%D0%B8%D0%BD",
    audioAvailable: true
  },
  {
    id: "lijepe-haljine-mnogo-kojeksta-ucine",
    title: "Лијепе хаљине много којешта учине",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9B%D0%B8%D1%98%D0%B5%D0%BF%D0%B5_%D1%85%D0%B0%D1%99%D0%B8%D0%BD%D0%B5_%D0%BC%D0%BD%D0%BE%D0%B3%D0%BE_%D0%BA%D0%BE%D1%98%D0%B5%D1%88%D1%82%D0%B0_%D1%83%D1%87%D0%B8%D0%BD%D0%B5",
    audioAvailable: true
  },
  {
    id: "maceha-i-pastorka",
    title: "Маћеха и пасторка",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9C%D0%B0%D1%9B%D0%B5%D1%85%D0%B0_%D0%B8_%D0%BF%D0%B0%D1%81%D1%82%D0%BE%D1%80%D0%BA%D0%B0",
    audioAvailable: true
  },
  {
    id: "milostiva-snaha-i-nemilostiva-svekrva",
    title: "Милостива снаха и немилостива свекрва",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9C%D0%B8%D0%BB%D0%BE%D1%81%D1%82%D0%B8%D0%B2%D0%B0_%D1%81%D0%BD%D0%B0%D1%85%D0%B0_%D0%B8_%D0%BD%D0%B5%D0%BC%D0%B8%D0%BB%D0%BE%D1%81%D1%82%D0%B8%D0%B2%D0%B0_%D1%81%D0%B2%D0%B5%D0%BA%D1%80%D0%B2%D0%B0",
    audioAvailable: true
  },
  {
    id: "opet-zmija-mladozenja",
    title: "Опет змија младожења",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9E%D0%BF%D0%B5%D1%82_%D0%B7%D0%BC%D0%B8%D1%98%D0%B0_%D0%BC%D0%BB%D0%B0%D0%B4%D0%BE%D0%B6%D0%B5%D1%9A%D0%B0",
    audioAvailable: true
  },
  {
    id: "ocina-zakletva",
    title: "Очина заклетва",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9E%D1%87%D0%B8%D0%BD%D0%B0_%D0%B7%D0%B0%D0%BA%D0%BB%D0%B5%D1%82%D0%B2%D0%B0",
    audioAvailable: true
  },
  {
    id: "pobratimski-darovi",
    title: "Побратимски дарови",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9F%D0%BE%D0%B1%D1%80%D0%B0%D1%82%D0%B8%D0%BC%D1%81%D0%BA%D0%B8_%D0%B4%D0%B0%D1%80%D0%BE%D0%B2%D0%B8",
    audioAvailable: true
  },
  {
    id: "pravda-i-krivda",
    title: "Правда и кривда",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9F%D1%80%D0%B0%D0%B2%D0%B4%D0%B0_%D0%B8_%D0%BA%D1%80%D0%B8%D0%B2%D0%B4%D0%B0",
    audioAvailable: true
  },
  {
    id: "tri-jegulje",
    title: "Три јегуље",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A2%D1%80%D0%B8_%D1%98%D0%B5%D0%B3%D1%83%D1%99%D0%B5",
    audioAvailable: true
  },
  {
    id: "usud",
    title: "Усуд",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A3%D1%81%D1%83%D0%B4",
    audioAvailable: true
  },
  {
    id: "careva-kci-ovca",
    title: "Царева кћи овца",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A6%D0%B0%D1%80%D0%B5%D0%B2%D0%B0_%D0%BA%D1%9B%D0%B8_%D0%BE%D0%B2%D1%86%D0%B0",
    audioAvailable: true
  },
  {
    id: "crno-jagnje",
    title: "Црно јагње",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A6%D1%80%D0%BD%D0%BE_%D1%98%D0%B0%D0%B3%D1%9A%D0%B5",
    audioAvailable: true
  },
  {
    id: "cudnovata-dlaka",
    title: "Чудновата длака",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A7%D1%83%D0%B4%D0%BD%D0%BE%D0%B2%D0%B0%D1%82%D0%B0_%D0%B4%D0%BB%D0%B0%D0%BA%D0%B0",
    audioAvailable: true
  },
  {
    id: "cudnovata-tica",
    title: "Чудновата тица",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A7%D1%83%D0%B4%D0%BD%D0%BE%D0%B2%D0%B0%D1%82%D0%B0_%D1%82%D0%B8%D1%86%D0%B0",
    audioAvailable: true
  },
  {
    id: "cudotvorni-noz",
    title: "Чудотворни нож",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%A7%D1%83%D0%B4%D0%BE%D1%82%D0%B2%D0%BE%D1%80%D0%BD%D0%B8_%D0%BD%D0%BE%D0%B6",
    audioAvailable: true
  },
  {
    id: "zla-maceha",
    title: "Зла маћеха",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%97%D0%BB%D0%B0_%D0%BC%D0%B0%D1%9B%D0%B5%D1%85%D0%B0",
    audioAvailable: true
  },
  {
    id: "kako-su-radile-onako-su-i-prosle",
    title: "Како су радиле онако су и прошле",
    author: "Вук Стефановић Караџић",
    sourceUrl: "https://sr.wikisource.org/wiki/%D0%9A%D0%B0%D0%BA%D0%BE_%D1%81%D1%83_%D1%80%D0%B0%D0%B4%D0%B8%D0%BB%D0%B5_%D0%BE%D0%BD%D0%B0%D0%BA%D0%BE_%D1%81%D1%83_%D0%B8_%D0%BF%D1%80%D0%BE%D1%88%D0%BB%D0%B5",
    audioAvailable: true
  }
] as const;

export const fullStoryContentIds = fullStoryContentCatalog.map(({ id }) => id);

export const hasFullStoryContent = (id: string): boolean => (
  (fullStoryContentIds as readonly string[]).includes(id)
);
